"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarkCss = void 0;
const getMarkCss = (themeId) => {
    return `
    .${themeId} span.monospace {
      font-family: 'Courier', sans-serif;
    }

    .${themeId} span.smallcaps {
      font-variant: small-caps;
    }

    .${themeId} span.sansserif {
      font-family: 'PT Sans';
    }
  `;
};
exports.getMarkCss = getMarkCss;
